import { HttpParams } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { BaseCrudService } from "app/shared/_utils/services/base-crud-service";
import { QueryOperator } from "app/shared/_utils/services/query-operator.enum";
import { LazyLoadEvent } from "primeng/api";
import { PettyCashAccount } from "../entities/petty-cash-account";
import { PettyCashDetail } from "../entities/petty-cash-detail";


@Injectable()
export class PettyCashDetailService extends BaseCrudService<PettyCashDetail> {

  public uri = '/api/pettyCashDetail/';

  constructor(injector: Injector) {
    super(injector);
    // console.log('Instance PettyCashAccountService');
  }

  buildSentence(entity?: PettyCashDetail, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.documentNumber ?
          `documentNumber${QueryOperator.Contain}${entity.documentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.documentType && entity.documentType.id) {
        query = query.concat(
          `documentType.id${QueryOperator.Equal}${entity.documentType.id}${QueryOperator.Split}`
        );
      }
      if (entity.pettyCashMaster && entity.pettyCashMaster.id) {
        query = query.concat(
          `pettyCashMaster.id${QueryOperator.Equal}${entity.pettyCashMaster.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    // this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'startContractDate');

    return this.httpParams;
  } 

}



// WEBPACK FOOTER //
// ./src/app/core/services/petty-cash-detail.service.ts